import { Navigate } from "react-router-dom"
import { useAppSelector } from "../../hooks/store-hooks"
import { IProps } from "./types/IProps"

export const PrivateRoute = (props: IProps) => {
  const isValid = useAppSelector((state) => state.auth.isValid)

  return (
    <>
      {
        isValid ? (
          <>
            {props.children}
          </>
        ) : <Navigate to="/authentication/login" />
      }
    </>
  )
}